






























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { esmaxDashboardEventBus } from '@/setup';
import { Bar, HorizontalBar, Line, Doughnut, Radar } from 'vue-chartjs';

import GraficoBarra from './TiposGraficos/GraficoBarra.vue';
import GraficoBarraLateralStaked from './TiposGraficos/GraficoBarraLateralStaked.vue';
import GraficoBarraLateral from './TiposGraficos/GraficoBarraLateral.vue';
import GraficoBarraStacked from './TiposGraficos/GraficoBarraStacked.vue';
import GraficoPie from './TiposGraficos/GraficoPie.vue';
import GraficoGrid from './TiposGraficos/GraficoGrid.vue';
import GraficoMapa from './TiposGraficos/GraficoMapa.vue';
const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    GraficoGrid,
    GraficoMapa,
    GraficoBarra,
    GraficoBarraStacked,
    GraficoBarraLateralStaked,
    GraficoBarraLateral,
    GraficoPie,
    'ag-grid-vue': AgGridVue,
    barComp: Bar,
    barHComp: HorizontalBar,
    lineComp: Line,
    doughnutComp: Doughnut,
    radarComp: Radar,
  },
})
export default class GraficosGrid extends Vue {
  countKey: number = 0;
  dataReady: Boolean = false;
  data: any;
  graficosData: any[] = [];
  pluginOptions: any = {
    datalabels: {
      anchor: 'end',
      align: 'end',
      padding: -3,
      labels: {
        value: {
          color: 'black',
        },
      },
    },
  };

  ortographyDict: any = {
    ULTIMA: 'ÚLTIMA',
    VEHICULO: 'VEHÍCULO',
    DETENCION: 'DETENCIÓN',
    UBICACION: 'UBICACIÓN',
  };

  get getNewKey(): string {
    this.countKey += 1;
    return this.countKey.toString();
  }
  //   @Prop({ default: {} }) readonly data: any;
  // suport [17:12] Christian Saez Peñaloza

  reset() {
    this.dataReady = false;
  }
  filtrarElemento(graficosData: any) {
    return graficosData.filter((data: any) => {
      console.log(data);
      return (
        data.tipo_grafico != 'tabla' && data.tipo_grafico != 'barra_lateral'
      );
    });
  }
  filtrarTabla(graficosData: any) {
    return graficosData.filter((data: any) => {
      return (
        data.tipo_grafico == 'tabla' || data.tipo_grafico == 'barra_lateral'
      );
    });
  }
  esStacked(dash: any) {
    return (
      dash.name == 'Ranking por Transportista' ||
      dash.name == 'Ranking por Vehículo' ||
      dash.name == 'Ranking por Conductor'
    );
  }
  noEsStacked(dash: any) {
    return (
      dash.name == 'Cantidad de Alertas por Flota' ||
      dash.name == 'Cantidad de Alertas por Grupo'
    );
  }
  getRef(aux: string) {
    let ref: any;
    ref = aux.toLowerCase();
    ref = ref.split(' ').join('_');
    return ref;
  }
  mounted() {
    esmaxDashboardEventBus.$on('dataReady', (data: any) => {
      this.data = data;
      this.dataReady = true;
      let newData: any[] = [];
      Object.values(this.data).map(function(value, index) {
        if (typeof value == 'object') {
          newData = [...newData, value];
        }
      });
      this.graficosData = newData;
      if (this.graficosData) {
        this.graficosData.map((elemento: any) => {
          elemento.namekey = elemento.name + this.getNewKey;
        });
      }
      this.$forceUpdate();
    });
    esmaxDashboardEventBus.$on('resetGrid', () => {
      this.reset();
    });
  }

  valideText(text: string): string {
    let returnText: string = '';
    let array: string[] = text.split(' ');
    for (let word of array) {
      returnText += this.ortographyDict[word]
        ? this.ortographyDict[word]
        : word + ' ';
    }
    return returnText;
  }
}
